export default {
  fobtrading: {
    menuItem: "FOB Trading — Operation",
    pageTitle: "Operation",
    quickSearchPlaceholder: "Search operation by text…",
    subtitle:
      "Negotiation, proforma and shippings in one simplified workspace.",
    landingTitle: "FOB Trading — Operation",
    landingHint:
      "Open an operation from a proforma: add the proforma id to the path, for example /operacion/ followed by the id, or start from the proforma record.",
    listOpenOperacionView: "Operation view",
    goProforms: "Go to proforms",
    loadError: "Could not load the operation.",
    proforma: "Proforma",
    negotiation: "Negotiation",
    shippings: "Shippings",
    openFullEdit: "Open full editor",
    noNegotiation: "This proforma has no linked negotiation.",
    noShippings: "No shippings linked yet.",
    shippingName: "Name",
    tabNegotiation: "Negotiation",
    tabProformShipping: "Proforma & shippings",
    tabDocsLogistics: "Documents & logistics",
    tabFinancialDashboard: "Operational Dashboard",
    tabCashResult: "Result",
    tabOperationBalance: "Operation balance",
    tabNegotiationHelp:
      "Review or edit the negotiation that originated this proforma.",
    tabProformHelp:
      "Edit the proforma and each shipping using the same forms as elsewhere in the app.",
    tabDocsHelp:
      "The same PDFs as on the proforma and shipping record screens: public views and Admin Links.",
    noPdfDocuments:
      "This tenant has no PDFs configured (public views or Admin Links) for the proforma or its shippings.",
    pdfDocuments: "PDF documents",
    pdfDocumentsHint:
      "Same links as on the record screen (CustomLinks: view and list sections). They open in a new tab.",
    collectionsSnapshotUnavailable:
      "Could not load the operational dashboard for this proforma. Check finance permissions or try again.",
    tabCashHelp:
      "Consolidated operation balance and result margins. Use the Operational Dashboard tab for staged collections and supplier payments by shipping.",
    collectionsAdvanceGuidanceTitle: "Operational dashboard",
    shippingInvoicesPendingHint:
      "Shipping invoices: {total} still to collect across {count} shipping(s) (invoice balance after proforma advance share and applicable credit notes).",
    shippingInvoiceCollectTitle: "Pending collections",
    shippingInvoiceCollectSubtitle:
      "Per shipping invoice: total billed, already collected (including proforma advance share on this invoice), and remaining balance.",
    shippingInvoiceColInvoiceTotal: "Invoice total",
    shippingInvoiceColCollected: "Collected",
    shippingInvoiceColRemaining: "Remaining",
    shippingInvoiceColCreditNotesHint: "Credit notes applied: −{amount}",
    shippingInvoiceColActions: "Action",
    shippingInvoiceCollectSingle: "Collect this invoice",
    shippingInvoiceCollectAll: "Collect all in one payment (applied to each invoice)",
    receiveAdvanceCollection: "Receive advance",
    collectionsNoCollectPermission:
      "You do not have permission to record collections. Finance (collects) or finance management is required.",
    financialNeedsModule:
      "Finance module is inactive or you lack access. Enable Finance and permissions to see the operational dashboard and result tab here.",
    shippingBlockTitle: "Shipping",
    expensesLinked: "Expenses",
    amount: "Amount",
    totalAppliedTo: "Total applied",
    paymentRemainingToApply: "Remaining to apply",
    remaining: "Remaining",
    shipping: "Shipping",
    paid: "Paid",
    payPayment: "Pay",
    markAsPaid: "Mark as paid",
    pending: "Pending",
    noPaymentsForProform: "No payments recorded for this proforma.",
    openRecordNewTab: "Open in new tab",
    paymentsAll: "Payments",
    collections: "Collections",
    clientSide: "Client",
    supplierSide: "Supplier",
    invoices: "Invoices",
    invoice: "Invoice",
    collected: "Collected",
    balance: "Balance",
    margins: "Margins",
    projectedMargin: "Projected margin",
    realMargin: "Real margin",
    currentMargin: "Current margin",
    projectedMarginHelp: "Negotiation gross margin, with the estimated interest replaced by the operation interest: projected to today while collections are pending, real once the last collection comes in.",
    projectedMarginHelpProform:
      "Proforma total minus the expenses entered in the proforma itself (supplier invoice, freight, commissions…).",
    projectedMarginHelpDefault: "Proforma total minus the shipping's estimated costs.",
    realMarginHelpDefault: "Total invoiced to the client minus the shipping's estimated costs.",
    currentMarginHelp:
      "Today cash snapshot: collected from client minus payments already marked as paid.",
    expected: "Expected",
    toCollect: "To collect",
    yes: "Yes",
    no: "No",
    appliedToExpenses: "Applied to expenses",
    collectStatus: "Status",
    collectedState: "Collected",
    requestPayment: "Request payment",
    requestFullPayment: "Request full payment",
    requestAdvancePayment: "Request advance",
    invalidExpenseForPayment:
      "Cannot request payment: the expense identifier is missing.",
    invalidShippingForAdvancePayment:
      "Cannot request advance: the shipping linked to this expense was not found.",
    paymentCreatedSuccessTitle: "Done",
    paymentCreatedSuccessBody: "Payment request was created successfully.",
    negotiationExpenses: {
      button: "Auto load expenses from negotiation",
      confirmTitle: "Load expenses from the negotiation?",
      confirmText:
        "They are created in {shipping}, each one already paid with its own payment, the same as when an operation is created from a negotiation:",
      confirmButton: "Load",
      cancelButton: "Cancel",
      doneTitle: "Expenses loaded",
      nothingToLoad: "The operation already has all the negotiation expenses.",
      nothingPendingTitle: "No expenses to load",
      noNegotiation:
        "This operation was not created from a negotiation, so there are no negotiation expenses to load.",
      loadError: "Could not load the negotiation expenses.",
    },
    realInterest: {
      title: "Financial cost",
      help: "The negotiation interest is estimated with assumed days. The operation interest uses the days between paying for the goods and the freight and collecting the client invoice (amount-weighted average date on each side; amounts collected above the invoice, such as a recharged expense, do not count): sale value × rate × days / 365. While collections are pending it is projected to today; with the last collection it becomes the real one and the Interest expense is adjusted automatically. If the collection comes before the payment, interest is 0.",
      estimated: "Estimated (negotiation)",
      projected: "Projected (as of today)",
      real: "Real (payments and collections)",
      days: "Days",
      interest: "Interest",
      rate: "Annual rate",
      base: "Sale value",
      paymentAvgDate: "Average payment",
      collectAvgDate: "Average client collection",
      currentExpense: "Interest expense booked",
      noExpense: "No Interest expense",
      negativeDays: "The collection came {days} days before the payment: interest is 0.",
      provisional: "Provisional: {amount} still to collect. Pending amounts count as if collected today, so interest grows each day of delay.",
      applied: "The Interest expense already matches the real interest: it was adjusted automatically with the last collection.",
      loadError: "Could not compute the real interest.",
      noPaymentYet: "Goods and freight not paid yet: the negotiation estimate applies.",
      marginEffect: "Effect on projected margin",
      notApplied: "The Interest expense could not be adjusted automatically:",
      provisionalNoAmount: "Provisional until the last collection comes in.",
      blockers: {
        no_negotiation: "The operation has no linked negotiation.",
        no_rate: "The negotiation has no interest rate.",
        no_base: "The negotiation has no sale value.",
        no_shipping: "The operation has no shipping.",
        multiple_shippings: "The operation has more than one shipping and there is no rule to split the interest.",
        no_payments: "No goods or freight payments marked as paid.",
        no_collects: "No client collections.",
        mixed_currency: "Payments or collections are in different currencies.",
        not_fully_collected: "The last collection has not come in yet.",
        duplicated_expense: "The shipping has more than one Interest expense.",
        expense_edited: "The Interest expense has manually entered payments: adjust it from the expense.",
        expense_in_accounting: "The Interest expense payment is already in accounting: adjust it from the payment.",
      },
    },
  },
};
